module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-inleft02.9446c8b5.svg";